import produce from "immer";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import TreeAPI from "../apis/TreeAPI";

const useCourse = ({ courseId }) => {
  const [course, setCourse] = useState({});

  useEffect(() => {
    const unsubscribe = TreeAPI.subscribeToCourse(
      courseId,
      (course) =>
        setCourse(
          produce((draft) => {
            const { id, value } = course;
            draft[id] = value;
          })
        ),
      (courseId) =>
        setCourse(
          produce((draft) => {
            draft[courseId] = undefined;
          })
        )
    );

    return () => unsubscribe();
  }, [courseId]);

  const updateCheckout = useCallback(
    ({ videoPromotion, priceTotal, isPromotion }) => {
      return TreeAPI.updateCheckout({
        courseId,
        videoPromotion,
        priceTotal,
        isPromotion,
      });
    },
    [courseId]
  );

  return {
    course,
    updateCheckout,
  };
};

export { useCourse };
